import React from "react";
import styled from "styled-components";

const MontserratText = (props) => {
  return <MontserratTextWrapper {...props} />;
};

export default MontserratText;

const MontserratTextWrapper = styled.div`
  font-family: "Montserrat";
  /* font-weight: normal; */
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  display: block;
  word-break: keep-all;
  white-space: pre-wrap;
`;
